module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Make a call","errorcall":"Error in Call, Please Retry!!","conect":"Conecting..."},"es":{"title":"Haz una llamada","errorcall":"Error en la Llamada, vuelve a intentar!!","conect":"Conectando..."}}')
  delete Component.options._Ctor
}
